var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.18595C23.117 3.57795 22.168 3.84195 21.172 3.96095C22.189 3.35195 22.97 2.38695 23.337 1.23695C22.386 1.80095 21.332 2.21095 20.21 2.43195C19.313 1.47495 18.032 0.876953 16.616 0.876953C13.437 0.876953 11.101 3.84295 11.819 6.92195C7.728 6.71695 4.1 4.75695 1.671 1.77795C0.381 3.99095 1.002 6.88595 3.194 8.35195C2.388 8.32595 1.628 8.10495 0.965 7.73595C0.911 10.017 2.546 12.151 4.914 12.626C4.221 12.814 3.462 12.858 2.69 12.71C3.316 14.666 5.134 16.089 7.29 16.129C5.22 17.752 2.612 18.477 0 18.169C2.179 19.566 4.768 20.381 7.548 20.381C16.69 20.381 21.855 12.66 21.543 5.73495C22.505 5.03995 23.34 4.17295 24 3.18595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.f6e6b55c67e2ff1e837f0cb4b55b6ac0.svg";
export { ForwardRef as ReactComponent };